import { render, staticRenderFns } from "./StoreUnitCard.vue?vue&type=template&id=e9a37fc2&scoped=true&"
import script from "./StoreUnitCard.vue?vue&type=script&lang=js&"
export * from "./StoreUnitCard.vue?vue&type=script&lang=js&"
import style0 from "./StoreUnitCard.vue?vue&type=style&index=0&id=e9a37fc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a37fc2",
  null
  
)

export default component.exports